import { ventilacionServices } from "@/mocks/serviceVentilacionData";

export default function VentilacionServices() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Servicios de ventilación
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Soluciones especializadas para cada necesidad
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Diseñamos, instalamos y mantenemos sistemas de ventilación mecánica que garantizan la
            calidad del aire y las condiciones ambientales de tus espacios.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {ventilacionServices.map((service, i) => (
            <div
              key={service.title}
              className="reveal rounded-xl border border-background-200 bg-background-50 p-6 hover:border-[#0087a4]/40 transition-colors"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-12 h-12 rounded-lg bg-[#0087a4]/10 text-[#0087a4] flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl`} />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 leading-snug">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}